import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectProfileDetailSearchText = createSelector(
  [(store: RootState) => store.profileDetail.searchText],
  (usersList) => usersList
);
